export const HeroArrow1 = () => {
  return (
    <>
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5_41)">
          <g filter="url(#filter0_d_5_41)">
            <path
              d="M97.6338 71.1268L97.6484 71.1106L97.6634 71.0949C98.2633 70.4644 98.2629 69.4277 97.6526 68.797L97.6317 68.7755L97.6117 68.7531L73.7822 42.0742C72.9669 41.2391 71.3438 41.688 71.3438 43.2422V54.9023V56.4023H69.8438C38.2904 56.4023 11.5795 35.8193 2.36467 7.36047C2.05438 9.94714 1.89063 12.5792 1.89063 15.2539C1.89063 52.7439 32.3109 83.1289 69.8633 83.1289H71.3633V84.6289V96.5039C71.3633 98.0588 72.9879 98.5075 73.8029 97.6707L97.6338 71.1268Z"
              fill="url(#paint0_linear_5_41)"
              stroke="white"
              strokeWidth="3"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_5_41"
            x="-3.60938"
            y="0.390625"
            width="107.221"
            height="107.215"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5_41"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_5_41"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_5_41"
            x1="95"
            y1="69"
            x2="-9.08147e-08"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3E6283" />
            <stop offset="0.510417" stopColor="#3E6283" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <clipPath id="clip0_5_41">
            <rect
              width="100"
              height="100"
              fill="white"
              transform="matrix(1 0 0 -1 0 100)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const HeroArrow2 = () => {
  return (
    <>
      <svg
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_180_1807)">
          <g filter="url(#filter0_d_180_1807)">
            <path
              d="M1.82899 40.1255L1.81445 40.1093L1.79945 40.0935C1.75254 40.0442 1.72115 39.9719 1.72142 39.8849C1.72168 39.7986 1.75293 39.7267 1.80187 39.6761L1.82271 39.6545L1.84268 39.6322L15.4195 24.432C15.4593 24.3931 15.4816 24.3898 15.4849 24.3893L15.4852 24.3893C15.4958 24.3874 15.5211 24.3863 15.5572 24.402C15.5934 24.4178 15.6267 24.4448 15.6503 24.4798C15.67 24.5092 15.695 24.5614 15.695 24.6565L15.695 31.3051V32.8051H17.195C34.4241 32.8051 49.1599 22.2117 55.2659 7.18957C55.2864 7.68958 55.2969 8.19231 55.2969 8.69771C55.2969 29.7174 38.2409 46.755 17.1839 46.755H15.6839V48.255V55.0261C15.6839 55.1212 15.6589 55.1734 15.6391 55.2028C15.6156 55.2378 15.5822 55.2648 15.546 55.2805C15.51 55.2962 15.4846 55.2952 15.474 55.2933L15.4737 55.2932C15.4704 55.2927 15.4478 55.2894 15.4075 55.2497L1.82899 40.1255Z"
              fill="url(#paint0_linear_180_1807)"
              stroke="white"
              strokeWidth="3"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_180_1807"
            x="-3.77856"
            y="0.222733"
            width="64.5754"
            height="64.5716"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_180_1807"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_180_1807"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_180_1807"
            x1="2.85106"
            y1="39.3435"
            x2="57.0196"
            y2="9.12313"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#009959" />
            <stop offset="0.510417" stopColor="#6FBF6B" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <clipPath id="clip0_180_1807">
            <rect
              width="57.0195"
              height="57.0195"
              fill="white"
              transform="translate(57.0195 57.0195) rotate(-180)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ModuleSectionLeaf = () => {
  return (
    <>
      <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7_1471)">
          <path
            d="M20.8206 74.6609C20.8233 74.7007 20.8407 74.7366 20.8674 74.7634L50.4226 51.4242L73.7329 21.8977C73.7329 21.8977 16.9419 15.8628 20.8206 74.6609Z"
            fill="#6FBF6B"
          />
          <path
            d="M73.733 21.8977L20.8674 74.7634C20.8941 74.7901 20.9301 74.8075 20.97 74.8102C79.7681 78.6889 73.733 21.8977 73.733 21.8977Z"
            fill="#009959"
          />
          <path
            d="M20.7619 74.7238C20.792 74.75 20.8296 74.7632 20.8674 74.7632L25.2629 37.3612L20.8674 0C20.8674 0 -23.5573 35.8899 20.7619 74.7238Z"
            fill="#6FBF6B"
          />
          <path
            d="M20.8674 0V74.7634C20.9052 74.7634 20.9429 74.7502 20.9729 74.724C65.2922 35.8899 20.8674 0 20.8674 0Z"
            fill="#009959"
          />
        </g>
        <defs>
          <clipPath id="clip0_7_1471">
            <rect width="75" height="75" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ModuleClickBtn = () => {
  return (
    <>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="72" height="72" rx="20" fill="white" fillOpacity="0.2" />
        <path
          d="M56.8207 36.2893H49.3625C49.1636 36.2893 48.9728 36.3683 48.8322 36.509C48.6915 36.6496 48.6125 36.8404 48.6125 37.0393C48.6108 38.5972 47.9911 40.0909 46.8895 41.1925C45.7878 42.2941 44.2942 42.9138 42.7363 42.9155H28.4827V37.0389C28.4827 36.8966 28.4423 36.7572 28.3661 36.6371C28.29 36.5169 28.1811 36.4208 28.0524 36.3602C27.9237 36.2995 27.7804 36.2767 27.6392 36.2944C27.498 36.3122 27.3648 36.3697 27.2551 36.4603L14.7021 46.816C14.6169 46.8864 14.5483 46.9748 14.5012 47.0749C14.4541 47.1749 14.4297 47.2841 14.4297 47.3946C14.4297 47.5052 14.4541 47.6144 14.5012 47.7144C14.5483 47.8144 14.6169 47.9028 14.7021 47.9733L27.2552 58.329C27.3649 58.4195 27.4982 58.477 27.6393 58.4947C27.7805 58.5124 27.9238 58.4896 28.0525 58.429C28.1812 58.3683 28.2899 58.2723 28.3661 58.1521C28.4423 58.0319 28.4827 57.8926 28.4827 57.7503V51.8738H42.7363C46.6692 51.8693 50.4399 50.305 53.2209 47.5239C56.0019 44.7429 57.5663 40.9723 57.5707 37.0393C57.5707 36.8404 57.4917 36.6496 57.3511 36.509C57.2104 36.3683 57.0197 36.2893 56.8207 36.2893Z"
          fill="#6FBF6B"
        />
        <path
          d="M15.1797 35.7113H22.6379C22.8368 35.7113 23.0276 35.6322 23.1682 35.4916C23.3089 35.3509 23.3879 35.1602 23.3879 34.9613C23.3896 33.4033 24.0093 31.9097 25.1109 30.8081C26.2126 29.7064 27.7062 29.0868 29.2642 29.0851H43.5178V34.9616C43.5177 35.1039 43.5581 35.2433 43.6343 35.3635C43.7105 35.4837 43.8193 35.5797 43.948 35.6404C44.0767 35.7011 44.22 35.7239 44.3612 35.7061C44.5024 35.6884 44.6356 35.6309 44.7454 35.5403L57.2983 25.1846C57.3835 25.1141 57.4521 25.0257 57.4992 24.9257C57.5463 24.8257 57.5707 24.7165 57.5707 24.6059C57.5707 24.4954 57.5463 24.3862 57.4992 24.2862C57.4521 24.1861 57.3835 24.0977 57.2983 24.0273L44.7452 13.6716C44.6355 13.581 44.5023 13.5235 44.3611 13.5058C44.2199 13.4881 44.0767 13.5109 43.948 13.5716C43.8193 13.6323 43.7105 13.7283 43.6343 13.8484C43.5581 13.9686 43.5177 14.108 43.5178 14.2502V20.1268H29.2642C25.3312 20.1312 21.5606 21.6956 18.7795 24.4766C15.9985 27.2577 14.4342 31.0283 14.4297 34.9613C14.4297 35.1602 14.5087 35.3509 14.6494 35.4916C14.79 35.6322 14.9808 35.7113 15.1797 35.7113Z"
          fill="#6FBF6B"
        />
      </svg>
    </>
  );
};
export const Bonusesshopimg = () => {
  return (
    <>
      <svg
        className="pe-2"
        width="36"
        height="32"
        viewBox="0 0 36 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.16239 6H33.4624L30.1749 19H10.4499M30.1749 23H11.5457L6.06655 2H2.77905"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.9832 29C29.1936 29 30.1748 28.1046 30.1748 27C30.1748 25.8954 29.1936 25 27.9832 25C26.7727 25 25.7915 25.8954 25.7915 27C25.7915 28.1046 26.7727 29 27.9832 29Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7373 29C14.9477 29 15.929 28.1046 15.929 27C15.929 25.8954 14.9477 25 13.7373 25C12.5269 25 11.5457 25.8954 11.5457 27C11.5457 28.1046 12.5269 29 13.7373 29Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const TrainerMuscle = () => {
  return (
    <>
      <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M72.6563 56.25C72.6563 60.4688 61.6055 72.6563 44.5313 72.6563C37.1175 72.7065 29.7652 71.3093 22.8867 68.543C23.9482 66.5279 25.7573 65.0091 27.9258 64.3125C28.0735 64.2694 28.2113 64.1977 28.3313 64.1013C28.4513 64.005 28.5512 63.8859 28.6252 63.751C28.6992 63.6161 28.7459 63.4679 28.7626 63.3149C28.7793 63.1619 28.7658 63.0071 28.7227 62.8594C28.6796 62.7117 28.6078 62.5739 28.5115 62.4538C28.4151 62.3339 28.2961 62.234 28.1611 62.16C28.0262 62.086 27.878 62.0393 27.725 62.0226C27.5721 62.0059 27.4173 62.0194 27.2695 62.0625C27.0352 62.1328 19.9219 64.4531 19.9219 71.4844C19.921 71.7949 19.7972 72.0924 19.5776 72.312C19.3581 72.5316 19.0605 72.6553 18.75 72.6563H3.51563C3.20512 72.6553 2.90758 72.5316 2.68802 72.312C2.46845 72.0924 2.34468 71.7949 2.34376 71.4844V35.1563C2.34322 35.0022 2.37317 34.8496 2.43187 34.7072C2.49057 34.5648 2.57687 34.4354 2.6858 34.3264C2.79472 34.2175 2.92412 34.1312 3.06654 34.0725C3.20896 34.0138 3.36159 33.9839 3.51563 33.9844C4.03126 33.9844 4.57032 33.9727 5.1211 33.9727C10.9688 33.9024 18.7266 33.8086 25.1133 40.6406C23.189 41.7479 21.5607 43.3038 20.3672 45.1758C20.2915 45.3097 20.2431 45.4573 20.2247 45.6101C20.2063 45.7628 20.2182 45.9176 20.2599 46.0657C20.3015 46.2138 20.372 46.3522 20.4673 46.473C20.5626 46.5937 20.6808 46.6944 20.8152 46.7694C20.9496 46.8443 21.0974 46.8919 21.2502 46.9094C21.4031 46.927 21.5579 46.9142 21.7057 46.8717C21.8536 46.8293 21.9916 46.758 22.1118 46.6621C22.232 46.5661 22.3321 46.4473 22.4063 46.3125C22.4883 46.1602 25.9922 39.8438 37.5 39.8438C49.0899 39.8438 52.5 46.1485 52.5938 46.3125C52.694 46.4949 52.8416 46.6467 53.0211 46.7519C53.2006 46.8571 53.4052 46.9118 53.6133 46.9102C53.8131 46.9096 54.01 46.8614 54.1875 46.7696C54.4577 46.6171 54.6563 46.3636 54.7398 46.0648C54.8233 45.766 54.7848 45.4463 54.6328 45.1758C53.1102 42.8278 50.9467 40.9653 48.3984 39.8086C49.3003 37.4522 50.3492 35.1547 51.5391 32.9297C51.5608 30.1407 51.226 27.3604 50.543 24.6563C52.7501 23.9117 54.8746 22.9418 56.8828 21.7617C57.0154 21.6837 57.1312 21.5803 57.2236 21.4574C57.316 21.3345 57.3832 21.1945 57.4214 21.0455C57.4595 20.8965 57.4678 20.7414 57.4458 20.5892C57.4237 20.437 57.3718 20.2907 57.2931 20.1586C57.2143 20.0265 57.1102 19.9113 56.9867 19.8196C56.8632 19.7279 56.7228 19.6615 56.5736 19.6243C56.4244 19.5871 56.2693 19.5797 56.1172 19.6026C55.9652 19.6255 55.8191 19.6783 55.6875 19.7578C55.5117 19.8516 49.4531 23.4961 44.5313 23.4375C41.7099 23.3296 38.9174 22.8287 36.2344 21.9492C35.7477 21.797 35.2997 21.5412 34.9214 21.1992C34.5431 20.8573 34.2433 20.4374 34.0429 19.9685C33.8424 19.4996 33.7459 18.9928 33.7601 18.4831C33.7743 17.9733 33.8988 17.4727 34.125 17.0156C34.2221 16.8273 34.3704 16.6702 34.5529 16.5624C34.7353 16.4546 34.9444 16.4005 35.1563 16.4063H42.1875C42.6494 16.4069 43.1068 16.3164 43.5336 16.1399C43.9604 15.9635 44.3482 15.7045 44.6748 15.3779C45.0014 15.0514 45.2603 14.6636 45.4368 14.2367C45.6132 13.8099 45.7038 13.3525 45.7031 12.8906V11.7188C45.7031 11.408 45.5797 11.1099 45.3599 10.8901C45.1401 10.6704 44.8421 10.5469 44.5313 10.5469C44.2205 10.5469 43.9224 10.6704 43.7026 10.8901C43.4828 11.1099 43.3594 11.408 43.3594 11.7188V12.8906C43.3585 13.2012 43.2347 13.4987 43.0151 13.7183C42.7956 13.9378 42.498 14.0616 42.1875 14.0625H35.3672C35.14 14.063 34.9178 13.995 34.7297 13.8675C34.5416 13.7401 34.3963 13.5589 34.3125 13.3477L33.6211 11.625C33.3175 10.8614 33.2907 10.0156 33.5454 9.23435C33.8001 8.45307 34.3203 7.78559 35.0156 7.34767L41.0274 3.58596C42.3333 2.7767 43.8386 2.34662 45.375 2.34377H54.4453C55.965 2.34056 57.4556 2.75963 58.751 3.55422C60.0463 4.34882 61.0954 5.48768 61.7813 6.84377C65.8359 14.918 72.6563 32.0977 72.6563 56.25Z"
          fill="#09F0FF"
        />
      </svg>
    </>
  );
};
export const TestimonysVideoPlayIcon = () => {
  return (
    <>
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_589_279)">
          <path
            d="M32.9999 0C16.9837 0 4 12.9837 4 28.9999C4 45.0162 16.9837 57.9999 32.9999 57.9999C49.0162 57.9999 61.9999 45.0162 61.9999 28.9999C61.9829 12.9909 49.0091 0.0171135 32.9999 0ZM32.9999 53.8571C19.2717 53.8571 8.14281 42.7282 8.14281 28.9999C8.14281 15.2717 19.2717 4.14281 32.9999 4.14281C46.7282 4.14281 57.8571 15.2717 57.8571 28.9999C57.8423 42.7221 46.7221 53.8423 32.9999 53.8571Z"
            fill="white"
          />
          <path
            d="M45.2129 28.0759C45.0121 27.6732 44.6857 27.3467 44.2829 27.146L27.7115 18.8602C26.6881 18.3489 25.444 18.7638 24.9326 19.7873C24.7888 20.075 24.714 20.3924 24.7141 20.7142V37.2857C24.7136 38.4297 25.6406 39.3575 26.7846 39.3581C27.1064 39.3582 27.4238 39.2835 27.7115 39.1396L44.2829 30.8539C45.3068 30.3436 45.7232 29.0998 45.2129 28.0759ZM28.857 33.9341V24.0658L38.7254 28.9999L28.857 33.9341Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_589_279"
            x="0"
            y="0"
            width="66"
            height="65.9999"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_589_279"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_589_279"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
